import { useCallback } from 'react';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { getReduxStore } from 'store/storeRegistry';
import { setReEnabledTab } from 'actions';
import { setTabsPersonalization } from 'actions/deviceSettings';
import { selectTabsPriority } from 'reducers/selectors/organiseTabs';
import { TAB_ROUTE_TO_KEY, } from 'features/settings/organize/constants';
import { getFinalOrganizeObj } from 'features/settings/organize/utils';
import { navigationRef } from 'utils/navigationv6';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const enableTabIfRemoved = (routeName, state, dispatch) => {
    const key = TAB_ROUTE_TO_KEY[routeName];
    const { priority, removed } = selectTabsPriority(state);
    if (!removed.includes(key)) {
        return;
    }
    const newPriority = [...priority, key];
    const newRemoved = removed.filter((tab) => tab !== key);
    dispatch(setTabsPersonalization(getFinalOrganizeObj(newPriority, newRemoved)));
    setTimeout(() => {
        dispatch(setReEnabledTab(key));
    }, 500);
};
/**
 * The single entry point that all tab navigation must go through. Re-enables a
 * removed tab (persisted + toast) before navigating, so deeplinks / push
 * notifications / CTAs are handled when targeting a tab the user removed.
 */
export const useTabNavigation = () => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const navigateToTab = useCallback((routeName, params) => {
        enableTabIfRemoved(routeName, store.getState(), dispatch);
        navigation.navigate(routeName, params);
    }, [dispatch, navigation, store]);
    return { navigateToTab };
};
/**
 * Imperative equivalent of {@link useTabNavigation} for non-React callers
 * (e.g. sagas) that navigate via `navigationRef` and reach the store directly.
 */
export const navigateToTab = (routeName, params) => {
    const store = getReduxStore();
    enableTabIfRemoved(routeName, store.getState(), store.dispatch);
    if (navigationRef.isReady()) {
        navigationRef.navigate(routeName, params);
    }
};
